export const FALLBACK_CUSTOM_MODEL_BASE_MODELS = [
  { id: 'gpt-5.5', label: 'Default (GPT-5.5)' },
  { id: 'gpt-5.6-terra', label: 'GPT-5.6 Terra' },
  { id: 'gpt-5.6-sol', label: 'GPT-5.6 Sol' },
  { id: 'gpt-5.6-luna', label: 'GPT-5.6 Luna' },
];
